import { useI18n } from '@oneaudi/i18n-context';
import { replaceVehicleTitleAndSubtitle } from '../../utils';
export const useDynamicAltText = (pictureKey, vehicle) => {
    const fallbackAltText = useI18n({
        id: 'stockcars.images.about.alt',
        defaultMessage: 'Image about {title} {subtitle}',
    });
    const dynamicAltTextWithPlaceholders = useI18n({
        id: `stockcars.stage.renderimages.${pictureKey}.alt`,
        defaultMessage: fallbackAltText,
    });
    return replaceVehicleTitleAndSubtitle(dynamicAltTextWithPlaceholders, vehicle);
};
